// Default ticket descriptions match the web workflow so the generated tickets share the same guidance.
export const DEFAULT_TICKET_DESCRIPTIONS = {
	agoraWallet: 'Do a test transaction in the Agora Markets app to verify that this works (it depends on GPS coordinates being set correctly)',
	posSignage: 'Bring physical POS signage pack and apply signage to micro market assets',
	directions: 'Please gather directions with visuals and servicing hours to ensure future drivers can locate the market.',
	fridgeSerialNumber: 'Upload a photo of fridge/freezer serial numbers for on-site assets.',
};

// Configuration for each ticket lets us render the inputs/buttons without duplicating the mutation wiring.
export const TICKET_FIELDS = [
	{
		key: 'agoraWallet',
		label: 'Agora Markets test transaction',
		requestField: 'createAgoraWalletTicket',
		createdFlag: 'agoraWalletTicketCreated',
		hint: 'Create a ticket for testing Agora Markets transactions.',
		field: 'agoraWalletTicketDescription',
	},
	{
		key: 'posSignage',
		label: 'POS signage',
		requestField: 'createPosSignageTicket',
		createdFlag: 'posSignageTicketCreated',
		hint: 'Create a ticket for applying POS signage.',
		field: 'posSignageTicketDescription',
	},
	{
		key: 'directions',
		label: 'Directions',
		requestField: 'createDirectionsTicket',
		createdFlag: 'directionsTicketCreated',
		hint: 'Create a ticket for recording market directions and servicing hours.',
		field: 'directionsTicketDescription',
	},
	{
		key: 'fridgeSerialNumber',
		label: 'Fridge serial number',
		requestField: 'createFridgeSerialNumberTicket',
		createdFlag: 'fridgeSerialNumberTicketCreated',
		hint: 'Create a photo-required ticket for collecting fridge/freezer serial numbers.',
		field: 'fridgeSerialNumberTicketDescription',
	},
];

export const toNumber = (value) => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	const parsed = Number(value);
	return Number.isNaN(parsed) ? null : parsed;
};
